export default "__VITE_ASSET__CewCoBka__"